const commonPages = [
  { id: 1, value: "user_details", name: "User Details" },
  { id: 2, value: "company_details", name: "Company Details" },
  { id: 3, value: "document_details", name: "Documentations" },
  { id: 4, value: "office_details", name: "Office Details" },
];

const specificPages = {
  consumer: [{id: 5, value: "consumer_details", name: "Consumer Details" }],
  generator: [{id: 5, value: "generator_details", name: "Generator Details" }],
  prosumer: [
    { id: 5, value: "consumer_details", name: "Consumer Details" },
    { id: 6, value: "generator_details", name: "Generator Details" },
  ],
  discom: [
    { id: 5, value: "discom_details", name: "Discom Details" },
    { id: 6, value: "generator_details", name: "Generator Details" },
    { id: 7, value: "consumer_details", name: "Consumer Details" },
  ],
  trader: [
    { id: 5, value: "discom_details", name: "Discom Details" },
    { id: 6, value: "generator_details", name: "Generator Details" },
    { id: 7, value: "consumer_details", name: "Consumer Details" },
  ],
  company_admin: [
    { id: 5, value: "bank_details", name: "Bank Details" },
  ],
};


const assignUniqueIds = (pages) => pages.map((page) => ({ ...page }));

export const registerPageList = Object.fromEntries(
  Object.entries(specificPages).map(([key, pages]) => [
    key,
    [...commonPages, ...assignUniqueIds(pages)],
  ])
);
